export const PARTNER_PROFIL_GET = "PARTNER_PROFIL_GET"

export const PARTNER_PROFIL_SET = "PARTNER_PROFIL_SET"

